<template>
  <div
    class="flex flex-col items-center mx-4 mt-3 px-2"
    id="small-receipt"
    :class="{
      'dir-ltr': $ctx.receiptLanguage == 'en',
      'dir-rtl': $ctx.receiptLanguage == 'ar'
    }"
  >
    <div class="flex flex-col items-center w-full" style="height: 100vh;">
      <!-- header info -->
      <div id="small-receipt-header" class="flex flex-col w-full">
        <div class="flex mt-6 justify-center w-full">
          <img :src="settingsStore.getValue('receipt_logo') ? settingsStore.storagePath + '/' + settingsStore.getValue('receipt_logo'): '@/assets/images/logo.svg'" :width="settingsStore.getValue('receipt_logo_width')" alt="" />
        </div>
      </div>

      <div id="small-receipt-body" class="w-full" style="color: black;">
        <!-- title -->
        <div class="flex flex-col w-full mt-2 items-center" style="color: black;">
          <h2 class="bg-gray-200 rounded py-1 px-2 font-bold mt-3 capitalize">
            {{ receiptTranslate("Purchase Order", "receipt.purchaseOrder") }}
          </h2>
        </div>

        <div :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}" class="flex flex-col items-center" style="color: black;">
          <div>
            <svg id="barcode" class="mt-3"></svg>
            <div class="flex items-center justify-center">
              <span class="font-bold mx-5" style="font-size: 20px;">{{
                barcodeText
              }}</span>
            </div>
          </div>
        </div>

        <div class="mx-5 mt-5 pb-2 text-sm self-end border-b border-black" style="color: black;">
          <p style="font-size: 12px;">
            {{ settingsStore.getValue('company_address') }}
          </p>
          <p :class="{'ltr-numbers': settingsStore.getValue('receipt_language') == 'ar'}">{{ settingsStore.getValue('company_phone1') + (settingsStore.getValue('company_phone2')? ` - ${settingsStore.getValue('company_phone2')}`: '') }}</p>
          <p>{{ settingsStore.getValue('company_email') }}</p>
          <p>{{ settingsStore.getValue('company_website') }}</p>
        </div>

        <div class="flex w-full px-5 justify-center mt-4" style="color: black;">
          <table class="order-info-table" :class="{ 'ar-receipt': $ctx.receiptLanguage == 'ar' }">
            <tr :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>
                  {{ receiptTranslate("Vendor", "receipt.vendor") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">
                  {{
                    order.vendor?.name
                  }}
                </p>
              </td>
            </tr>
            <tr v-if="order.customer" :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>
                  {{ receiptTranslate("Customer", "receipt.customer") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">
                  {{
                    order.customer?.name
                  }}
                </p>
              </td>
            </tr>
            <tr v-if="order.manualNumber">
              <td>
                <p>
                  {{ receiptTranslate("Manual No", "receipt.manualNumber") }}
                </p>
              </td>
              <td>
                <p class="font-bold mx-5">
                  {{
                    order.manualNumber
                  }}
                </p>
              </td>
            </tr>
<!--            <tr :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">-->
<!--              <td>-->
<!--                <p>-->
<!--                  {{ receiptTranslate("Location", "receipt.location") }}-->
<!--                </p>-->
<!--              </td>-->
<!--              <td>-->
<!--                <p v-if="$ctx.receiptLanguage == 'en'" class="font-bold ">-->
<!--                  {{ order.location?.enName || "" }}-->
<!--                </p>-->
<!--                <p v-if="$ctx.receiptLanguage == 'ar'" class="font-bold ">-->
<!--                  {{ order.location?.arName || "" }}-->
<!--                </p>-->
<!--              </td>-->
<!--            </tr>-->
            <tr v-if="order.referenceableExternalID" :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>
                  {{ receiptTranslate("Order No", "receipt.orderNo") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">{{ order.referenceableExternalID }}</p>
              </td>
            </tr>
            <tr v-if="settingsStore.getValue('hide_cashier_name_in_receipt') != 'true'">
              <td>
                <p>
                  {{ receiptTranslate("Cashier", "receipt.cashier") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">{{ order.user?.fullName }}</p>
              </td>
            </tr>
            <tr>
              <td>
                <p>
                  {{ receiptTranslate("Date & Time", "receipt.dateAndTime") }}
                </p>
              </td>
              <td>
                <p class="font-bold ">
                  {{ parseFormat(order.createdAt) }}
                </p>
              </td>
            </tr>
            <tr v-if="order.notes" :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
              <td>
                <p>
                  {{ receiptTranslate("Order Notes", "receipt.orderNotes") }}
                </p>
              </td>
              <td>
                <p class="font-bold " dir="ltr">
                  {{ order.notes }}
                </p>
              </td>
            </tr>
          </table>
        </div>

        <div class="flex flex-col px-5 items-center" style="color: black;">
          <div
              v-if="order?.pouchID"
              class="flex flex-col w-full mt-2 items-center"
          >
            <h2 class="bg-gray-200 rounded py-1 px-2 flex">
              <span>{{ receiptTranslate("Pouch #", "receipt.pouch") }}</span>
              <span class="flex justify-end custom-bold mx-2">
                {{ order?.pouchID }}
              </span>
            </h2>
          </div>
        </div>

        <!-- items -->
        <div class="w-full px-5 my-2 text-sm" :class="{'hidden': settingsStore.getValue('use_mini_sales_receipts_version') == 'true'}">
          <table class="receipt-table w-full" style="color: black;">
            <thead>
              <tr class="text-sm">
                <th>
                  {{ receiptTranslate("Item Name", "receipt.itemName") }}
                </th>
                <th>{{ receiptTranslate("Qty", "receipt.qty") }}</th>
              </tr>
            </thead>

            <tbody v-if="order.orderItems">
              <tr
                v-for="(oi, i) in order.orderItems"
                :key="i"
                class="text-sm"
                :class="{ 'receipt-row-border': !oi.item.isSerialized }"
              >
                <td class="text-sm reciept-cell">
                  <div>
                    <span>{{ oi.item.name }}</span>
                    <span v-if="oi.packInfo?.packID" class="mx-1">{{ ` - ${getPackName(oi)}, ${oi.packInfo.packQuantity} ${t('pcs')}` }}</span>
                  </div>
                  <data v-if="oi.item.isSerialized" class="flex gap-2 flex-wrap">
                    <small v-for="ois in oi.orderItemSerials" class="bg-gray-200 rounded-md px-1">{{ ois.itemSerial?.number }}</small>
                  </data>
                  <small>{{ oi.notes }}</small>
                </td>

                <td>{{ oi.quantity }}</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>

      <div
        id="small-receipt-footer"
        v-if="settingsStore.getValue('show_receipts_thecky_footer') == 'true'"
        class="flex justify-center self-center w-full mt-auto"
      >
        <div
          class="flex items-center justify-between py-2 px-4 mt-2 mb-4"
          style="bottom: 0px; width: 95%; border-top: 2px solid #BDC7D6"
        >
          <p><img src="@/assets/images/thecky-qr.png" style="height: 25px;"/></p>
          <p><img src="@/assets/images/footer.svg" style="height: 25px;"/></p>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";

import {i18nOrderMessages} from "@/models/sales/Order";
import {PurchaseOrder as Order,  PurchaseOrderItem as OrderItem} from "@/models/inventory/PurchaseOrder";

import { parseFormat } from "@/utils/date";
import { useI18n } from "vue-i18n";
import { Transaction } from "@/models/accounting/Transaction";
import JsBarcode from "jsbarcode";
import {useSettingsStore} from "@/stores/settingsStore";

export default defineComponent({
  components: {},

  setup() {
    const { t } = useI18n({
      messages: {
        en: {
          ...i18nOrderMessages.en
        },
        ar: {
          ...i18nOrderMessages.ar,
          purchaseOrderNo: 'رقم طلب الشراء',
          receipt: {
            vendor: 'المورّد',
            purchaseOrder: "طلب شراء",
            type: "نوع الطلب",
            location: "المتجر",
            orderNo: "رقم الطلب",
            cashier: "موظف الكاشير",
            dateAndTime: "التاريخ والوقت",
            orderNotes: "ملاحظات الطلب",
            itemName: "اسم المنتج",
            qty: "الكمية",
            manualNumber: 'الرقم الخاص',
            customer: 'الزبون',
            pouch: "رقم المحفظة",
          }
        }
      }
    });

    const settingsStore = useSettingsStore();

    return { t, settingsStore };
  },
  props: {
    order: {
      type: Order,
      required: true
    },
    transactions: {
      type: Array as PropType<Array<Transaction>>,
      required: true
    },
    barcodeText: {
      type: String,
      required: true
    }
  },
  mounted() {
    setTimeout(() => {
      JsBarcode("#barcode", String(this.order.externalID!.slice()), {
        height: 50,
        displayValue: false
      });
    }, 100);
  },
  created() {
    // Add print CSS when component is created
    this.addPrintCSS();
  },
  beforeUnmount() {
    // Remove print CSS when component is about to be destroyed
    this.removePrintCSS();
  },
  methods: {
    parseFormat,
    print() {
      window.print();
    },
    addPrintCSS() {
      // Create a style element with a unique id
      const style = document.createElement("style");
      style.setAttribute("id", "print-css");
      style.textContent = `
          @media print {
            @page:first {
              size: A4;
              margin-left: 0;
              margin-right: 0;
              margin-top: 0px;
            }
    
            @page {
              size: A4;
              margin-left: 0;
              margin-right: 0;
              margin-top: 40px;
              margin-bottom: 30px;
            }
          }`;
      // Append the style to the document head
      document.head.appendChild(style);
    },
    removePrintCSS() {
      // Find and remove the style element
      const style = document.querySelector("#print-css");
      if (style && style.parentNode) {
        style.parentNode.removeChild(style);
      }
    },
    receiptTranslate(value: string, translateKey: string): string {
      return this.$ctx.receiptLanguage == "en"
        ? value
        : this.t(translateKey, this.$ctx.receiptLanguage);
    },
    getPackName(oi: OrderItem) {
      for (const ip of oi.item.itemPacks) {
        if (ip.id == oi.packInfo.itemPackID) {
          return this.$ctx.locale == 'en' ? ip.pack?.enName: ip.pack?.arName
        }
      }
    },
    orderHasPack(order: Order) {
      let has = false;
      for (const oi of order.orderItems) {
        if (oi.packInfo?.packID) {
          has = true;
          break
        }
      }
      return has;
    },
  }
});
</script>
<style>
.thecky-site {
  color: #000;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 3px;
}

#small-receipt {
  color: black;
  width: 80mm;
  overflow: scroll;
  background-color: #fff;
}
.small-account-statement-table table {
  table-layout: fixed;
  /* width: 200px; */
  border-collapse: collapse;
}

.small-account-statement-table tr:not(:last-child) {
  border-bottom: 1pt solid #bbbbbb;
}

.small-account-statement-table td {
  padding-top: 4px;
  padding-bottom: 2px;
  border-bottom: 1pt solid #bbbbbb;
}

.small-account-statement-table th,
td {
  width: auto;
  overflow: hidden;
}

.small-account-statement-table td:nth-child(1) {
  width: auto;
  min-width: 60px;
  overflow: hidden;
}

.small-account-statement-table td:nth-child(2) {
  width: auto;
  min-width: 130px;
  overflow: hidden;
}

.small-account-statement-table td:nth-child(3) {
  width: auto;
  min-width: 55px;
  overflow: hidden;
}

.small-account-statement-table td:nth-child(4) {
  width: auto;
  min-width: auto;
  overflow: hidden;
}

.header-table td:nth-child(1) {
  width: 120px;
}

.header-table td:nth-child(2) {
  width: 300px;
}

#small-receipt-header {
  margin-top: 10px;
}

#small-receipt-body {
  margin-top: 10px;
}

@media print {
  body * {
    page-break-after: avoid;
    visibility: hidden;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
  }

  #small-receipt,
  #small-receipt * {
    visibility: visible;
  }

  #small-receipt {
    color: black;
    display: block;
    position: absolute;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    overflow: visible;
    margin: 0cm;
  }

  #small-receipt-header {
    margin-top: 0;
  }

  #small-receipt-body {
    position: relative;
  }

  p,
  div {
    page-break-inside: avoid;
  }
}
</style>
